export const SUCCESS = '/backoffice/auth/SUCCESS';
export const REQUEST = '/backoffice/auth/REQUEST';
export const ERROR = '/backoffice/auth/ERROR';
export const VALIDATE_TOKEN = '/backoffice/auth/VALIDATE_TOKEN';
export const LOG_OUT = '/backoffice/auth/LOG_OUT';



// WEBPACK FOOTER //
// ./src/store/auth/types.js